import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section className="bg-cream px-4 py-6" data-id="element-235" data-mp="3kr5ss3ue71jp">
      <div className="mx-auto max-w-5xl" data-id="element-236" data-mp="3fz5ndvvjzgfq">
        <h2 className="text-center text-xl text-espresso sm:text-3xl" data-id="element-237" data-mp="3fy2w3mubjbza">
          Real People Who <span className="text-burnt" data-id="element-238" data-mp="3azt0jb4om9d5">Started In Their Kitchen</span>
        </h2>
        <div className="mt-3 grid gap-3 md:grid-cols-2 lg:grid-cols-3" data-id="element-239" data-mp="3700r6w7grz6q">
          {testimonials.map(testimonial => <figure key={testimonial.name} className="flex h-full flex-col rounded-lg border-2 border-cinnamon/30 bg-white p-3.5" data-id="element-240" data-mp="31ybfrfgbxji4">
              <div className="flex items-center gap-1" aria-label="5 out of 5 stars" data-id="element-241" data-mp="2s2i21sqvjjyr">
                {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-242" data-mp="v72ixpixvamv" data-mpi={index} />)}
              </div>
              <blockquote className="mt-1.5 flex-1 text-sm font-medium leading-snug text-espresso/85" data-id="element-243" data-mp="h5os1hpjsial">
                <QuoteIcon className="mb-1 h-4 w-4 text-cinnamon/60" aria-hidden="true" data-id="element-244" data-mp="m5b43ntn3sht" />
                {testimonial.quote}
              </blockquote>
              <figcaption className="mt-2 border-t border-cinnamon/20 pt-2" data-id="element-245" data-mp="79v3ezyk0ycg">
                <span className="block text-sm font-extrabold text-espresso" data-id="element-246" data-mp="c7dfgz7vbtoo">{testimonial.name}</span>
                <span className="block text-xs font-semibold text-cinnamon" data-id="element-247" data-mp="zx7tvl7u5qb1">{testimonial.detail}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}